import axios from "axios";

class CarsEffects {
  static controller = "Cars";

  // Get All Cars
  static getAllCars = async (payload) => {
    const response = await axios.post(`/${this.controller}/getAll`, payload);
    return response.data;
  };

  // Add Car
  static addCar = async (payload) => {
    const response = await axios.post(`/${this.controller}/AddOne`, payload);
    return response.data;
  };

  // Get Car By Id
  static getCarById = async (id) => {
    const response = await axios.get(
      `/${this.controller}/${id}`
    );
    return response.data;
  };

  // Edit Car
  static editCar = async (payload) => {
    const response = await axios.put(
      `/${this.controller}/${payload.id}`,
      payload.formData
    );
    return response.data;
  };

  // Delete Car
  static deleteCar = async (id) => {
    const response = await axios.put(`/${this.controller}/DeleteModel/${id}`);
    return response.data;
  };

  // Refresh Prices (Excel: variationcode, price)
  static refreshPrices = async (formData) => {
    const response = await axios.post(
      `/${this.controller}/refresh-prices`,
      formData
    );
    return response.data;
  };
}

export default CarsEffects;
